import { render } from "./contact_form_component.vue?vue&type=template&id=32035e94"
import script from "./contact_form_component.vue?vue&type=script&lang=js"
export * from "./contact_form_component.vue?vue&type=script&lang=js"

import "./contact_form_component.vue?vue&type=style&index=0&id=32035e94&lang=css"
script.render = render

export default script